// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--modalchangecolor{max-width:528px;background:#1c2735}.verte__menu{background-color:#1c2735}.verte-picker__canvas{border-radius:10px}.verte__controller{display:none}.verte-picker__cursor{border:1px solid #000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
